"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LucyFinalIndication = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
const news_sentiment_enum_1 = require("../../@types/outcoming/enum/news-sentiment.enum");
const specific_investor_mm_enum_1 = require("../../@types/outcoming/enum/specific-investor-mm.enum");
const lucy_general_indication_enum_1 = require("../../@types/outcoming/enum/lucy-general-indication.enum");
class LucyFinalIndication {
    constructor(investorType) {
        this.investorType = investorType;
    }
    getIndication(readableIndications) {
        if (!readableIndications) {
            return this.errorResponse();
        }
        switch (this.investorType) {
            case investor_type_enum_1.eInvestorType.DAY_TRADER:
                return this.getDayTraderIndication(readableIndications);
            case investor_type_enum_1.eInvestorType.SWING_TRADER:
                return this.getSwingTraderIndication(readableIndications);
            case investor_type_enum_1.eInvestorType.BUY_AND_HOLDER:
                return this.getHolderIndication(readableIndications);
        }
    }
    getDayTraderIndication(data) {
        const { extra: extraData, movingAverage: movingAverageData, fundamental: fundamentalData, technical: technicalData, } = data;
        let buyPoints = 0;
        let sellPoints = 0;
        let alertText = this.getDefaultAlertText();
        const allCountedPoints = [
            this.countNewsPoints(extraData),
            this.countMovingAveragePoints(movingAverageData),
            this.countTechnicalPoints(technicalData),
        ];
        allCountedPoints.forEach((countedPoints) => {
            buyPoints += countedPoints.buy;
            sellPoints += countedPoints.sell;
        });
        if (fundamentalData &&
            fundamentalData !== 'error' &&
            fundamentalData !== 'empty') {
            alertText =
                "Para o perfil 'Agressivo' não é levado em conta os fatores fundamentalistas da empresa.";
        }
        if (buyPoints > sellPoints) {
            return this.buyResponse(alertText);
        }
        else if (sellPoints > buyPoints) {
            return this.sellResponse(alertText);
        }
        else {
            return this.neutralResponse(alertText);
        }
    }
    getSwingTraderIndication(data) {
        const { extra: extraData, movingAverage: movingAverageData, fundamental: fundamentalData, technical: technicalData, } = data;
        let buyPoints = 0;
        let sellPoints = 0;
        const allCountedPoints = [
            this.countNewsPoints(extraData),
            this.countMovingAveragePoints(movingAverageData),
            this.countTechnicalPoints(technicalData),
            this.countFundamentalPoints(fundamentalData),
        ];
        allCountedPoints.forEach((countedPoint) => {
            buyPoints += countedPoint.buy;
            sellPoints += countedPoint.sell;
        });
        if (buyPoints > sellPoints + 1) {
            return this.buyResponse();
        }
        else if (sellPoints > buyPoints + 1) {
            return this.sellResponse();
        }
        else {
            return this.neutralResponse();
        }
    }
    getHolderIndication(data) {
        const { extra: extraData, movingAverage: movingAverageData, fundamental: fundamentalData, technical: technicalData, } = data;
        let buyPoints = 0;
        let sellPoints = 0;
        const allCountedPoints = [
            this.countNewsPoints(extraData),
            this.countMovingAveragePoints(movingAverageData),
            this.countTechnicalPoints(technicalData),
            this.countFundamentalPoints(fundamentalData),
        ];
        allCountedPoints.forEach((countedPoints) => {
            buyPoints += countedPoints.buy;
            sellPoints += countedPoints.sell;
        });
        if (buyPoints > sellPoints + 2) {
            return this.buyResponse();
        }
        else if (sellPoints > buyPoints + 2) {
            return this.sellResponse();
        }
        else {
            return this.neutralResponse();
        }
    }
    countTechnicalPoints(techIndication) {
        var _a, _b;
        const countedPoints = {
            buy: 0,
            sell: 0,
        };
        if (techIndication !== 'error') {
            const qntBuyPoints = (_a = techIndication === null || techIndication === void 0 ? void 0 : techIndication.summary) === null || _a === void 0 ? void 0 : _a.qntBuy;
            const qntSellPoints = (_b = techIndication === null || techIndication === void 0 ? void 0 : techIndication.summary) === null || _b === void 0 ? void 0 : _b.qntSell;
            if (qntBuyPoints > qntSellPoints) {
                countedPoints.buy++;
            }
            else if (qntSellPoints > qntBuyPoints) {
                countedPoints.sell++;
            }
        }
        return countedPoints;
    }
    countMovingAveragePoints(mmIndication) {
        var _a;
        const countedPoints = {
            buy: 0,
            sell: 0,
        };
        if (mmIndication !== 'error') {
            const indicationByInvestor = (_a = mmIndication === null || mmIndication === void 0 ? void 0 : mmIndication.specificInvestorType) === null || _a === void 0 ? void 0 : _a.value;
            if (indicationByInvestor === specific_investor_mm_enum_1.eSpecificInvestorMMInd.BUY) {
                countedPoints.buy++;
            }
            else if (indicationByInvestor === specific_investor_mm_enum_1.eSpecificInvestorMMInd.SELL) {
                countedPoints.sell++;
            }
        }
        return countedPoints;
    }
    countNewsPoints(extraIndications) {
        var _a;
        const countedPoints = {
            buy: 0,
            sell: 0,
        };
        if (extraIndications !== 'empty') {
            const sentiment = (_a = extraIndications === null || extraIndications === void 0 ? void 0 : extraIndications.news) === null || _a === void 0 ? void 0 : _a.sentiment;
            if (sentiment === news_sentiment_enum_1.eNewsSentiment.BUY) {
                countedPoints.buy++;
            }
            else if (sentiment === news_sentiment_enum_1.eNewsSentiment.SELL) {
                countedPoints.sell++;
            }
        }
        return countedPoints;
    }
    countFundamentalPoints(funIndication) {
        var _a, _b, _c;
        const countedPoints = {
            buy: 0,
            sell: 0,
        };
        if (funIndication !== 'empty' && funIndication !== 'error') {
            const qntBuyPoints = (_a = funIndication === null || funIndication === void 0 ? void 0 : funIndication.summary) === null || _a === void 0 ? void 0 : _a.qntBuy;
            const qntSellPoints = (_b = funIndication === null || funIndication === void 0 ? void 0 : funIndication.summary) === null || _b === void 0 ? void 0 : _b.qntSell;
            const qntNeutralPoints = (_c = funIndication === null || funIndication === void 0 ? void 0 : funIndication.summary) === null || _c === void 0 ? void 0 : _c.qntNeutral;
            const pointsToIncrement = this.investorType === investor_type_enum_1.eInvestorType.BUY_AND_HOLDER ? 2 : 1;
            if (qntBuyPoints > qntSellPoints && qntBuyPoints > qntNeutralPoints) {
                countedPoints.buy += pointsToIncrement;
            }
            else if (qntSellPoints > qntBuyPoints &&
                qntSellPoints > qntNeutralPoints) {
                countedPoints.sell += pointsToIncrement;
            }
        }
        return countedPoints;
    }
    buyResponse(alertText = this.getDefaultAlertText()) {
        return {
            text: 'Compra',
            indicationNumber: lucy_general_indication_enum_1.eLucyGeneralIndication.BUY,
            alert: alertText,
            color: '#66bb6a',
        };
    }
    neutralResponse(alertText = this.getDefaultAlertText()) {
        return {
            text: 'Espera por melhores oportunidades',
            indicationNumber: lucy_general_indication_enum_1.eLucyGeneralIndication.NEUTRAL,
            alert: alertText,
            color: '#fdd835',
        };
    }
    sellResponse(alertText = this.getDefaultAlertText()) {
        return {
            text: 'Venda',
            indicationNumber: lucy_general_indication_enum_1.eLucyGeneralIndication.SELL,
            alert: alertText,
            color: '#ef5350',
        };
    }
    errorResponse() {
        return {
            text: '?',
            indicationNumber: 0,
            alert: 'Infelizmente, houve um erro desconhecido',
            color: '#fdd835',
        };
    }
    getDefaultAlertText() {
        return 'A análise acima reflete apenas a opinião da nossa inteligência artificial sobre o ativo, não é uma indicação direta de compra ou venda.';
    }
}
exports.LucyFinalIndication = LucyFinalIndication;
//# sourceMappingURL=lucy-final.indication.js.map